export function convertTimestamp(seconds) {
  return [
    Math.floor(parseInt(seconds, 10) / 3600) % 24,
    Math.floor(parseInt(seconds, 10) / 60) % 60,
    parseInt(seconds, 10) % 60
  ]
    .map(v => v < 10 ? '0' + v : v)
    .filter((v,i) => v !== '00' || i > 0)
    .join(':');
}